import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=5edf07cd&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"
import style0 from "./Documents.vue?vue&type=style&index=0&id=5edf07cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf07cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edf07cd')) {
      api.createRecord('5edf07cd', component.options)
    } else {
      api.reload('5edf07cd', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=5edf07cd&scoped=true&", function () {
      api.rerender('5edf07cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/documents/Documents.vue"
export default component.exports